import * as Yup from 'yup';

export const optionSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  ruName: Yup.string().required('Required'),
});
